// const axios = require('axios/dist/axios')
import axios from 'axios'
const assign = require('lodash.assign')
const merge = require('lodash.merge')
const keys = require('lodash.keys')
const defaultOptions = {
  /**
   * axios options
   */
  method: 'get',
  // baseURL: 'https:///API_V2',
  // baseURL: 'http:///API_V2',
  baseURL: 'https://course.auoktalk.com/api',
  withCredentials: true,
  /**
   * custom options
   */
  cache: false, // 是否使用缓存数据
  checkLogin: false, // 是否依赖登录
  formData: false // 是否提交formData
}

function Api () {
  this._requestOptions = defaultOptions
  this._cacheSchema = {}
  this._createOptions = {}

  /**
   * 区分通用请求，与注册模块请求
   * 通用模块保存在common中，
   * 注册模块名自定义
   */
  this.common = {}

  /**
   * 中间件容器
   */
  this.middlewares = []
}

Api.prototype = {
  /**
   * 标准化响应数据
   * 处理服务端未返回code的情况
   */
  _standardizeResponse (responseData, targetKey = 'code') {
    responseData = typeof responseData === 'string' ? JSON.parse(responseData) : responseData

    let data
    const objectKeys = keys(responseData)
    if (objectKeys.indexOf(targetKey) > -1) {
      data = responseData
    } else {
      data = {
        code: 0,
        message: 'success',
        data: responseData
      }
    }

    return data
  },

  /**
   * 缓存数据
   */
  _cacheData (options, data) {
    if (options.cache) {
      this._cacheSchema[options.url] = data
    }
  },

  /**
   * 发送请求
   * @param {*} url
   * @param {*} data
   * @param {*} options
   */
  _request (url, data, options) {
    options = merge({}, this._requestOptions, options, { url, data })

    // 读取缓存数据
    if (options.cache && this._cacheSchema[options.url]) return Promise.resolve(this._cacheSchema[options.url])

    // 规范参数格式
    options.method = options.method.toUpperCase()
    return new Promise((resolve, reject) => {
      const { baseURL, url, data, method, headers = {} } = options
      resolve(this._requestPackage(options, method, `${baseURL}${url}`, data, headers))
    })
    // if (os.type === 'weixin' && os.name === 'mp') {
    //   return new Promise((resolve, reject) => {
    //     _requestPackage(method, `${baseURL}${url}`, data)
    //     const { baseURL, url, data, method } = options
    //     // axios.defaults.adapter = config => {
    //     //   console.log('config', config)
    //     //   return new Promise((resolve, reject) => {
    //     //     return wx.request({
    //     //       method,
    //     //       url: `${baseURL}${url}`,
    //     //       header: config.headers,
    //     //       data,
    //     //       success: data => {
    //     //         const standardizeData = this._standardizeResponse(data)
    //     //         this._cacheData(options, standardizeData)
    //     //         resolve(standardizeData)
    //     //       },
    //     //       fail: reject
    //     //     })
    //     //   })
    //     // }
    //   })
    // } else {
    //   // 处理get请求参数
    //   if (options.method === 'GET') {
    //     options.params = options.data
    //   }

    //   // 处理formData
    //   if (options.formData && options.method === 'POST') {
    //     let f = new FormData()
    //     toPairs(options.data).forEach(([key, value]) => {
    //       f.append(key, value)
    //     })
    //     options.data = f
    //   }

    //   // 接口有可能不返回code字段，需做兼容
    //   options.transformResponse = originResponse => {
    //     return this._standardizeResponse(originResponse)
    //   }

    //   return this._runMiddleware(options)
    // }
  },

  _requestPackage (options, type = 'get', url, params, headers) {
    /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
    */
    // 设置请求头
    axios.defaults.headers = headers
    axios.defaults.headers['third-appid'] = window.localStorage.getItem('wkAppId')

    // eslint-disable-next-line eqeqeq
    if (type == 'post' || type == 'POST') {
      return new Promise((resolve, reject) => {
        axios.post(url, params)
          .then(res => {
            const standardizeData = this._standardizeResponse(params)
            this._cacheData(options, standardizeData)
            resolve(res.data)
          })
          .catch(err => {
            reject(err.data)
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        axios.get(url, {
          params: params
        }).then(res => {
          const standardizeData = this._standardizeResponse(params)
          this._cacheData(options, standardizeData)
          resolve(res.data)
        }).catch(err => {
          reject(err.data)
        })
      })
    }
  },

  /**
   * 注册中间件
   * @param {Function} middleware 通过use传入的中间件
   */
  _registerMiddleware (middleware) {
    this.middlewares.push(middleware)
  },

  /**
   * 运行 Middleware
   * @param {Object} options 最终的可用参数
   */
  _runMiddleware (options) {
    let i = 0

    return new Promise((resolve, reject) => {
      const next = () => {
        const handler = this.middlewares[i++]

        if (handler) {
          handler(options, next)
        } else {
          axios(options).then(res => {
            this._cacheData(options, res.data)
            resolve(res.data, res)
          }).catch(err => reject(err))
        }
      }

      next()
    })
  },

  /**
   * 注册单条api
   * @param {String} url api请求地址
   * @param {Object} options 请求选项
   * @return {Function} request function
   */
  create (url = '', options = {}) {
    // 生成一个接口id
    // const _id = Number(Math.random().toString().substr(3,10) + Date.now()).toString(36)
    // options.url = url
    // this._createOptions[_id] = options

    // 处理需要登录的情况
    // 获取登录后的wps_sid，若无则调用登录方法
    return data => this._request(url, data, options)
  },

  /**
   * 注册api模块
   * @param {Object} apiModule 模块信息
   * @param {String} moduleName 模块名
   * @return {Object} 当前注册的模块
   */
  createModule (apiModule = {}, moduleName = 'common') {
    if (this[moduleName] && moduleName !== 'common') {
      return console.error('module already exists')
    } else {
      // 区分注册模块
      if (moduleName === 'common') {
        this['common'] = assign({}, this['common'], apiModule)
      } else {
        this[moduleName] = apiModule
      }
    }

    return this[moduleName]
  },

  /**
   * 暴露给外部的中间件注册接口
   * @param {Function} middleware 中间件
   */
  use (middleware) {
    if (typeof middleware !== 'function') {
      return console.error('[api] middleware should be a function')
    }
    this._registerMiddleware(middleware)
  }
}

export default new Api()
